<template>
    <div class="content">

      <h1>Visual Studio Beginner Tricks</h1>
      <p>
        Learning shortcuts and built-in features in Visual Studio can significantly improve your workflow.
        By forcing yourself to use these shortcuts daily, they will become second nature and help you
        navigate large codebases more efficiently.
      </p>

      <h2>Essential Shortcuts for Beginners</h2>

      <h3>Quick File & Class Navigation</h3>
      <p>
        Instantly find any file or class in your project using:
      </p>
      <span class="pill">Ctrl + ,</span>

      <h3>Multi-Line Editing</h3>
      <p>
        Edit multiple lines at once by holding <span class="pill">Alt</span> and clicking + dragging.
        This works not only in Visual Studio but in many other Microsoft products as well.
      </p>

      <h3>Quick Property Creation</h3>
      <p>
        If you start using a property that doesn’t exist, Visual Studio can auto-generate it for you.
      </p>
      <pre class="cpr-code-block">
        <code class="language-csharp">
          var model = new EmptyClass();
          int i = 0;
          model.CreateMyProperty = i;
        </code>
      </pre>
      <p>
        Press <span class="pill">Ctrl + .</span> then <span class="pill">Enter</span>, and Visual Studio will automatically create the property.
      </p>
      <p><strong>Gotchas:</strong></p>
      <ul>
        <li>It may add <code>internal</code> instead of <code>public</code>, depending on where it is created.</li>
        <li>If you're not using PascalCase for public properties, it may not generate correctly.</li>
      </ul>

      <h2>More Useful Shortcuts</h2>

      <h3>Navigation & Code Editing</h3>
      <ul>
        <li><span class="pill">Ctrl + T</span> - Search for any symbol (class, method, property, etc.)</li>
        <li><span class="pill">F12</span> - Go to definition</li>
        <li><span class="pill">Ctrl + -</span> - Go back to the last cursor position</li>
        <li><span class="pill">Ctrl + Shift + -</span> - Go forward again</li>
      </ul>

      <h3>Refactoring & Code Cleanup</h3>
      <ul>
        <li><span class="pill">Ctrl + K, Ctrl + D</span> - Format document</li>
        <li><span class="pill">Ctrl + .</span> - Show quick actions (e.g., add missing using statements, refactor methods)</li>
        <li><span class="pill">Ctrl + R, R</span> - Rename a variable, method, or class</li>
      </ul>

      <h3>Debugging</h3>
      <ul>
        <li><span class="pill">F9</span> - Toggle a breakpoint</li>
        <li><span class="pill">F5</span> - Start debugging</li>
        <li><span class="pill">Shift + F5</span> - Stop debugging</li>
        <li><span class="pill">F10</span> - Step over</li>
        <li><span class="pill">F11</span> - Step into a method</li>
      </ul>

      <h3>Commenting Code</h3>
      <ul>
        <li><span class="pill">Ctrl + K, Ctrl + C</span> - Comment selected lines</li>
        <li><span class="pill">Ctrl + K, Ctrl + U</span> - Uncomment</li>
      </ul>

      <h3>Miscellaneous</h3>
      <ul>
        <li><span class="pill">Ctrl + Shift + B</span> - Build solution</li>
        <li><span class="pill">Shift + Alt + Enter</span> - Toggle full-screen mode</li>
      </ul>

      <h2>Final Thoughts</h2>
      <p>
        These shortcuts will save you hours in the long run! Commit to using them, and over time, they'll
        feel as natural as typing.
      </p>

    </div>

</template>

<script>
  import Prism from 'prismjs';
  import "prismjs/components/prism-csharp";
  import '@/assets/prism-vsc-dark-plus.css';

  export default {
    data() {
      return {       
      };
    },
    mounted() {
      Prism.highlightAll();
    }
  };
</script>
